import {
  getQuery,
  OnboardingEntitiesQueryResponse,
  OnboardingEntitiesQueryVariables,
  UpdateOnboardingStatusMutation
} from '@prophecy/queries/common/onboarding/query';

import { toFabricObject } from '../../data/apis/fabricUtils';
import { guessQueryName, makeGraphQlCallWithoutShareTokens, toGraphQlError } from '../../data/util';
import { replayToken } from '../../utils/replayToken';
import { shareToken } from '../../utils/shareToken';
import { captureException } from '../sentry';
import { GqlErrorTags, SentryTags } from '../sentry/SentryTags';

export { UpdateOnboardingStatusMutation };
export type { OnboardingEntitiesQueryResponse };

export async function fetchOnboardingDetails(
  payload: OnboardingEntitiesQueryVariables,
  isSqlProject: boolean,
  hasAirflow: boolean
) {
  const currentLoggedUserLoggedInId = replayToken.loggedInUserID ?? shareToken.loggedInUserId;
  let currentPayload = { ...payload };
  if (currentLoggedUserLoggedInId) {
    currentPayload.uid = currentLoggedUserLoggedInId;
  }
  const OnboardingEntitiesQuery = getQuery(isSqlProject, hasAirflow);

  const queryName = guessQueryName(OnboardingEntitiesQuery);

  try {
    const _response = await makeGraphQlCallWithoutShareTokens<OnboardingEntitiesQueryResponse>(
      OnboardingEntitiesQuery,
      currentPayload
    );

    if (_response.User?.onboardingEntities.fabric) {
      _response.User.onboardingEntities.fabric = toFabricObject(_response.User.onboardingEntities.fabric);
    }
    if (_response.User?.onboardingEntities.sqlFabric) {
      _response.User.onboardingEntities.sqlFabric = toFabricObject(_response.User.onboardingEntities.sqlFabric);
    }
    if (_response.User?.onboardingEntities.analystFabric) {
      _response.User.onboardingEntities.analystFabric = toFabricObject(_response.User.onboardingEntities.analystFabric);
    }

    return _response.User?.onboardingEntities;
  } catch (_errorResponse) {
    const { error } = toGraphQlError(_errorResponse);
    captureException({
      exception: error,
      errorTags: { [SentryTags.ProphecyErrorGqlType]: queryName || GqlErrorTags.QueryError }
    });

    throw _errorResponse;
  }
}
